import { Select, Switch } from '@mantine/core';
// utils
import useSettingsStore from '@/store/settings.ts';

const Settings = () => {
    const settings = useSettingsStore((state) => state.settings);
    const setSettings = useSettingsStore((state) => state.setSettings);

    const handleTimeZoneChange = (value: string | null) => {
        if (value) {
            setSettings({ timeZone: value });
        }
    };

    const handleUTCChange = () => {
        setSettings({ isUTC: !settings.isUTC });
    };

    const timeZones = Intl.supportedValuesOf('timeZone');
    return (
        <div className="grid grid-cols-2 gap-4">
            <div>
                <Select
                    searchable
                    className="mb-4"
                    data={timeZones}
                    disabled={settings.isUTC}
                    label="Local time"
                    placeholder="Pick timezone"
                    value={settings.timeZone}
                    onChange={handleTimeZoneChange}
                />
                <Switch
                    checked={settings.isUTC}
                    label="Use UTC time"
                    onChange={handleUTCChange}
                />
            </div>
        </div>
    );
};

export default Settings;
